export const retryDelay = (retryAttempt: number = 1) => {
  // For the first 3 attempts, use a unified base delay
  let baseDelay = 1000; // 1 second for attempts 1-3

  // For attempts greater than 3, increase the delay linearly with a cap
  if (retryAttempt > 3) {
    const maximumBackoff = 5000; // cap at 5 seconds
    baseDelay = Math.min(2000 + 500 * (retryAttempt - 4), maximumBackoff);
  }

  // Add jitter (20% of the base delay) to avoid synchronization issues
  const jitter = baseDelay * 0.2 * Math.random();
  return baseDelay + jitter;
};
